import { Subscribable } from 'knockout';
import { CardsScoreAnswer } from 'models/cardsScoreAnswer';
import pattern from 'patterns/cardsScoreAnswer';
import { WCCContentCardsScoreAnswerBlock } from '../blocks/cardsScoreAnswer/cardsScoreAnswer';
import WCCContentContext from '../context';
import WCCContentPatternRule from './pattern';

export default class WCCContentCardsScoreAnswersRule extends WCCContentPatternRule {
    protected pattern = pattern;

    constructor(private answers: Subscribable<Array<CardsScoreAnswer>>) {
        super();
    }

    protected process([content, answerContentId]: RegExpMatchArray, context: WCCContentContext) {
        const answer = this.answers.find(a => a.contentId() == answerContentId);

        return new WCCContentCardsScoreAnswerBlock({
            topicId: context.topicId,
            content: content,            
            answer: answer
        });
    }
}